import { useState } from 'react'
import createHomeStyles from 'src/view/home/homeStyles'
import VideoPlayer from 'src/view/videoPlayer/VideoPlayer'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import { Box, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const ItemVideo2 = ({ video, isThisTheActiveVideo, ...rest }) => {
  const navigate = useNavigate()
  const classes = createHomeStyles({ isThisTheActiveVideo, small: true })

  const [stateIsMouseOver, setStateIsMouseOver] = useState(false)

  const toggleItem = () => {
    if (rest.isLive) {
      navigate(`/`)
    } else {
      navigate(`/${video.id}`)
    }
    window.scrollTo({ top: -0, behavior: 'smooth' })
  }

  const onMouseEnterThePlayer = () => {
    setStateIsMouseOver(true)
  }

  const onMouseLeaveThePlayer = () => {
    setStateIsMouseOver(false)
  }

  const playButtonOrIsPlayingToRender = (
    <Box component="div" sx={classes.cellButtons}>
      <PlayCircleOutlineIcon sx={classes.iconPlay} />
    </Box>
  )

  return (
    // <Box component="div"  onClick={toggleItem}>
    <Grid container direction="row" wrap="nowrap" sx={{ marginBottom: '8px' }} onClick={toggleItem}>
      <Grid
        size={{ xs: 6 }}
        sx={classes.videoInCell}
        onMouseEnter={onMouseEnterThePlayer}
        onMouseLeave={onMouseLeaveThePlayer}
      >
        <VideoPlayer srcObj={video.src} poster={video.thumbnailUrl} play={stateIsMouseOver} />
        {playButtonOrIsPlayingToRender}
      </Grid>

      <Grid size={{ xs: 6 }} sx={{ textAlign: 'left', whiteSpace: 'normal', paddingLeft: '8px' }}>
        <div>{video.title}</div>
      </Grid>
    </Grid>
    // </Box>
  )
}

export default ItemVideo2
